export interface ISystemStatus {
    isOnline: boolean;
}

export class SystemStatus implements ISystemStatus {
    isOnline: boolean;

    constructor(isOnline: boolean) {
        this.isOnline = isOnline;
    }
}



/** WEBPACK FOOTER **
 ** ./app/main/systemHealthRetriever/system-status.ts
 **/